import styled from 'styled-components'

export const Row = styled.div`
  display: flex;
  padding-left: 0.5em;
  align-items: center;
`
export const HeaderRow = Row.extend`
  background-color: steelblue;
  color: #fefefe;
  font-size: 1.1em;
  height: 30px;
  font-weight: bold;
  border-radius: 3px;
  dispay: flex;
  height: 40px;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;
`
export const Col = styled.div`
  flex: ${({ grow }) => grow || '0'} 0 ${({ width }) => width || '120px'};
  padding: 5px;
`
